import axios from 'axios'
import i18n from 'i18n'

const BASE_URL = 'https://field-notebook-staging.k8s.cultivointeligente.com.br'

export const getFieldNotebooks = async (params) => {
  return await axios.get(BASE_URL + '/field_notebook/company_forms', { params: { company_id: params.company_id }, headers: { Authorization: `Bearer ${params.jwt}`} })
}

export const getHistory = async (params) => {
  return await axios.get(BASE_URL + '/field_notebook/archive_history?company_id=' + params.company_id + '&form_id=' + params.form_id, { headers: { Authorization: `Bearer ${params.jwt}` } })
}

export const postAnswerForm = async (params) => {
  return await axios.post(BASE_URL + '/field_notebook/form_answer', { response: params.response }, { headers: { Authorization: `Bearer ${params.jwt}` } })
}

export const formatSecondaryText = (forms) => {
  let text = `${i18n.t('take_note_of')}: `
  const num = forms.length >= 3 ? 3 : forms.length
  for (let i = 0; i < num; i++) {
    text = text + forms[i].title +', '
  }
  text = text.slice(0, -2) + '...'
  return text
}

export const formatHistoricText = (forms) => {
  let text = `${i18n.t('historic_of')}: `
  const num = forms.length >= 3 ? 3 : forms.length
  for (let i = 0; i < num; i++) {
    text = text + forms[i].title +', '
  }
  text = text.slice(0, -2) + '...'
  return text
}


export const formatArchives = archives => {
  const newArray = archives.map(archive => {
    return {
      ...archive,
      secondary: formatSecondaryText(archive.forms),
      historyText: formatHistoricText(archive.forms)
    }
  })
  return (newArray)
}

export const formatArchiveForms = archive => {
  const forms = archive.forms || []
  const newArray = forms.map(form => {
    return {
      ...form,
    }
  })

  return (newArray)
}

export const getMaxAnswersNumber = history => {
  var maxAnswers = 0;

  history.forEach(record => {
    const answersNumber = record.answers.length

    if (answersNumber > maxAnswers) maxAnswers = answersNumber;
  })

  return maxAnswers;
}

export const createColumnsName = maxAnswers => {
  const columnsName = []

  for (let i = 1; i <= maxAnswers; i++) {
    columnsName.push(`Resposta ${i}`);
  }

  return columnsName;
}

export const isRealNumber = number => !!(String(number).replace(',', '.') % 1)

export const formatAnswer = answer => {
  if (isRealNumber(answer)) return Number(answer).toFixed(2)
  return answer
}

export const formatHistory = history => {
  const newArray = history.map(record => {
    return {
      form_name: record.form_name,
      user_name: record.user_name,
      form_date: record.form_date,
      answers: record.answers.map(answer => answer.question + ' : ' + formatAnswer(answer.answer) + ' ')
    }
  })
  var headers = {
    form_name: `${i18n.t('form_name')}`,
    user_name: `${i18n.t('username')}`,
    form_date: `${i18n.t('registration_date')}`,
    answers: `${i18n.t('answer_one')}`
  }
  const newHeaders = {
    ...headers,
    answers: createColumnsName(getMaxAnswersNumber(history))
  }
  newArray.unshift(newHeaders)

  return (newArray)
}

export function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray
  var str = ''

  for (var i = 0; i < array.length; i++) {
    var line = ''
    for (var index in array[i]) {
      if (line !== '') line += ','

      line += array[i][index]
    }

    str += line + '\r\n'
  }

  return str
}


export function exportCSVFile(items, fileTitle) {

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items)

  var csv = convertToCSV(jsonObject)

  var exportedFilenmae = fileTitle + '.csv' || 'export.csv'

  var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, exportedFilenmae)
  } else {
    var link = document.createElement("a")
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", exportedFilenmae)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export function getParams(query) {
  const urlParams = new URLSearchParams(query)
  return {
    jwt: urlParams.get('jwt'),
    company_id: urlParams.get('company_id'),
    o: urlParams.get('org_id')
  }
}